import { render, staticRenderFns } from "./ProductVariations.vue?vue&type=template&id=7b68f61d&scoped=true&"
import script from "./ProductVariations.vue?vue&type=script&lang=ts&"
export * from "./ProductVariations.vue?vue&type=script&lang=ts&"
import style0 from "./ProductVariations.vue?vue&type=style&index=0&id=7b68f61d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b68f61d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronDownIcon16px: require('/var/www/packages/theme/components/icons/chevron-down/ChevronDownIcon16px.vue').default,AtomsProductDropdown: require('/var/www/packages/theme/components/atoms/ProductDropdown.vue').default})
